import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Job } from "@/lib/schema";
import { COMMON_CLASSES } from "@/lib/jobConstants";
import { formatRewardAmount } from "@/lib/textUtils";
import airPointsIcon from "@/assets/jobs/icon_air_points.svg";

interface JobSidebarProps {
  job: Job;
  onReferSomeone: () => void;
}

export function JobSidebar({ job, onReferSomeone }: JobSidebarProps) {
  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Referral Reward */}
      {job.rewardInAirPoints && job.rewardInAirPoints > 0 && (
        <Card 
          className="border-0 shadow-sm text-white"
          style={{ backgroundColor: '#2D2D2D' }}
        >
          <CardContent 
            className="p-0"
            style={{
              display: 'flex',
              padding: '16px',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '8px'
            }}
          >
            <img 
              src={airPointsIcon} 
              alt="Referral Reward"
              className="h-6 w-6 sm:h-7 sm:w-7"
              style={{filter: 'brightness(0) saturate(100%) invert(100%)'}}
            />
            <p className="text-2xl sm:text-3xl font-bold space-grotesk text-white">
              R{formatRewardAmount(job.rewardInAirPoints)}
            </p>
            <p className="text-xs font-medium uppercase leading-tight tracking-[0.07px] text-gray-400">
              REFERRAL REWARD
            </p>
            <p className="text-xs text-gray-400 mt-2">
              Earn this reward when your referral is successfully hired
            </p>
          </CardContent>
        </Card>
      )}

      {/* Refer Someone Button */}
      <Card className={COMMON_CLASSES.card}>
        <CardContent className="p-4 sm:p-6">
          <Button 
            variant="primary"
            onClick={onReferSomeone}
            className="w-full"
            size="lg"
          >
            Refer Someone
          </Button>
          <p className={`${COMMON_CLASSES.text.small} normal-case tracking-normal mt-3 text-center`}>
            Know someone perfect for this role? Submit their details and earn a reward when they're hired.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
